import { categories } from '@/mocks/home';

interface CategoriesProps {
  onSelect: (categoryId: string) => void;
}

export default function Categories({ onSelect }: CategoriesProps) {
  return (
    <section id="categories" className="w-full bg-secondary-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 text-sm font-label font-medium text-secondary-700">
              <span className="w-6 h-[2px] bg-secondary-500" aria-hidden="true"></span>
              主题分类
            </span>
            <h2 className="mt-4 font-heading font-bold text-2xl md:text-4xl text-foreground-950 leading-snug">
              按主题进入你关心的那一类
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
              点击任意分类，会直接跳转到热门合集区并自动筛选出该主题下的所有归档条目，省去一页页翻找的时间。
            </p>
          </div>
        </div>

        <div className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => (
            <button
              key={cat.id}
              type="button"
              onClick={() => onSelect(cat.id)}
              className="group flex items-start gap-4 w-full text-left bg-background-50 border border-background-200 rounded-lg p-5 md:p-6 hover:border-secondary-400 transition-colors cursor-pointer"
            >
              <span className="w-12 h-12 shrink-0 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-700 transition-colors group-hover:bg-secondary-500 group-hover:text-background-50">
                <i className={`${cat.icon} text-2xl`} aria-hidden="true"></i>
              </span>
              <span className="flex flex-col flex-1">
                <span className="flex items-center justify-between gap-2">
                  <span className="font-heading font-semibold text-base md:text-lg text-foreground-950">
                    {cat.name}
                  </span>
                  <i
                    className="ri-arrow-right-line text-foreground-400 group-hover:text-secondary-600 group-hover:translate-x-0.5 transition-all"
                    aria-hidden="true"
                  ></i>
                </span>
                <span className="mt-1.5 text-sm leading-relaxed text-foreground-600">{cat.desc}</span>
                <span className="mt-3 text-xs font-label text-secondary-700">
                  收录 {cat.count} 条归档
                </span>
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}